import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

import Label from '../vera-score/vera-label';
import { quartileColorScale } from '../../styles/graphs';
import { scoreToQuartileScale } from '../../components/graphs/utils';

export interface Props {
  className?: string;
  scoreRange: [number, number];
  scoreCount: number;
  entityName?: string;
}

class EntityScoresPopover extends React.Component<Props, any> {
  public static defaultProps: Props = {
    scoreCount: 0,
    scoreRange: [0, 4],
  };

  public render() {
    const {
      className,
      scoreCount,
      entityName,
      scoreRange: [scoreStart, scoreEnd],
    } = this.props;
    const quartileColor = quartileColorScale(scoreToQuartileScale(scoreStart));
    const rangeSpansMultiple = Math.abs(scoreStart - scoreEnd) > 1;
    const scoreText = rangeSpansMultiple
      ? `${scoreStart} - ${scoreEnd}`
      : scoreStart;

    return (
      <div className={className}>
        <Label
          className="scores-label"
          style={{ backgroundColor: quartileColor }}
        >
          {scoreText}
        </Label>
        <div className="entity-count">{`${scoreCount} ${entityName}`}</div>
      </div>
    );
  }
}

export default styled(EntityScoresPopover)`
  min-width: 120px;
  text-align: center;
  padding: 1em;

  .scores-label {
    min-width: 32px;
    padding: 0 5px;
    width: auto;
  }

  .entity-count {
    margin-top: 0.75em;
  }
`;
